import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 * 
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { NestedError } from "abweb/dto/exception/NestedError";
import { ScopedStorageImpl } from "abweb/utils/ScopedStorageImpl";
export class LocalUserSettingsStorage {
  constructor() {
    _defineProperty(this, "scopedStorage", new ScopedStorageImpl(LocalUserSettingsStorage.USER_SETTINGS_NAMESPACE));
  }
  async getValue(key) {
    try {
      return this.scopedStorage.get(key) ?? undefined;
    } catch (e) {
      throw new NestedError(`Failed to get value for user setting ${key} with namespace ${LocalUserSettingsStorage.USER_SETTINGS_NAMESPACE}`, e);
    }
  }
  async setValue(key, value) {
    try {
      this.scopedStorage.put(key, value);
    } catch (e) {
      throw new NestedError(`Failed to update value for user setting ${key} with namespace ${LocalUserSettingsStorage.USER_SETTINGS_NAMESPACE}`, e);
    }
  }
  async removeValue(key) {
    try {
      this.scopedStorage.remove(key);
    } catch (e) {
      throw new NestedError(`Failed to remove user setting ${key} with namespace ${LocalUserSettingsStorage.USER_SETTINGS_NAMESPACE}`, e);
    }
  }
}
_defineProperty(LocalUserSettingsStorage, "USER_SETTINGS_NAMESPACE", "AbInitio.UserSetting");
//# sourceMappingURL=LocalUserSettingsStorage.js.map
